(() => {
  if (window.__contactPageSectionInit) return;
  window.__contactPageSectionInit = true;

  const selectors = {
    section: '[data-contact-section]',
    reveal: '[data-contact-reveal]'
  };

  const instances = new Map();

  class ContactSection {
    constructor(section) {
      this.section = section;
      this.items = Array.from(section.querySelectorAll(selectors.reveal));
      this.enableAnimations = section.dataset.enableAnimations === 'true';
      this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.observer = null;
      this.abortController = new AbortController();
      this.onMotionChange = this.onMotionChange.bind(this);
    }

    connect() {
      this.prefersReducedMotion.addEventListener('change', this.onMotionChange, { signal: this.abortController.signal });
      this.setupObserver();
    }

    disconnect() {
      this.abortController.abort();
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
    }

    onMotionChange() {
      this.setupObserver();
    }

    setupObserver() {
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }

      if (!this.enableAnimations || this.prefersReducedMotion.matches || this.items.length === 0) {
        this.items.forEach((item) => item.classList.add('is-visible'));
        return;
      }

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            this.observer?.unobserve(entry.target);
          });
        },
        {
          threshold: 0.2,
          rootMargin: '0px 0px -10% 0px'
        }
      );

      this.items.forEach((item, index) => {
        item.style.transitionDelay = `${Math.min(index * 60, 260)}ms`;
        this.observer?.observe(item);
      });
    }
  }

  const mount = (root = document) => {
    root.querySelectorAll(selectors.section).forEach((section) => {
      if (instances.has(section)) return;
      const instance = new ContactSection(section);
      instances.set(section, instance);
      instance.connect();
    });
  };

  const unmountBySectionId = (sectionId) => {
    const target = Array.from(instances.entries()).find(([section]) => {
      const wrapper = section.closest('[id^="shopify-section-"]');
      return wrapper && wrapper.id === `shopify-section-${sectionId}`;
    });

    if (!target) return;

    const [section, instance] = target;
    instance.disconnect();
    instances.delete(section);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => mount());
  } else {
    mount();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const sectionId = event.detail?.sectionId;
    if (sectionId) unmountBySectionId(sectionId);
    mount(event.target instanceof Element ? event.target : document);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const sectionId = event.detail?.sectionId;
    if (!sectionId) return;
    unmountBySectionId(sectionId);
  });
})();
